import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import MarketingActionsEvents from './MarketingActionsEvents';

import MarketingActionsDetailsSectionInfo from './details/sections/MarketingActionsDetailsSectionInfo';
import MarketingActionsDetailsSectionSecondaryInfo from './details/sections/MarketingActionsDetailsSectionSecondaryInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<MarketingActionsDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_SECONDARY_INFO_SECTION" />
			<MarketingActionsDetailsSectionSecondaryInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="maac_descriptionhtml"
				value={props.model.maac_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
		</>
	),
	events: MarketingActionsEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
